<div [formGroup]="form">
  <div
    class="repeatable-card-field"
    *ngFor="let mtc of mtcs; let i = index">
    <ng-container [ngSwitch]="context?.TSK">
      <app-input-vocabulary-autocomplete
        *ngSwitchCase="'OA'"
        [formControlName]="i"
        [vocabularyName]="'V_OA_MTC'"
        [placeholder]="'Materia e tecnica (MTC)'">
      </app-input-vocabulary-autocomplete>
      <app-input-vocabulary-autocomplete
        *ngSwitchCase="'OA'"
        [formControlName]="i"
        [vocabularyName]="'V_OA_MTC'"
        [placeholder]="'Materia e tecnica (MTC)'">
      </app-input-vocabulary-autocomplete>
      <app-input-vocabulary-autocomplete
        *ngSwitchCase="'D'"
        [formControlName]="i"
        [vocabularyName]="'V_D_MTC'"
        [placeholder]="'Materia e tecnica (MTC)'">
      </app-input-vocabulary-autocomplete>
      <app-input-vocabulary-autocomplete
        *ngSwitchCase="'MI'"
        [formControlName]="i"
        [vocabularyName]="'V_MI_MTC'"
        [placeholder]="'Materia e tecnica (MTC)'">
      </app-input-vocabulary-autocomplete>
      <app-input-vocabulary-autocomplete
        *ngSwitchCase="'S'"
        [formControlName]="i"
        [vocabularyName]="'V_S_MTC'"
        [placeholder]="'Materia e tecnica (MTC)'">
      </app-input-vocabulary-autocomplete>

      <app-input-vocabulary-autocomplete
        *ngSwitchDefault
        [formControlName]="i"
        [vocabularyName]="'Vocabolario MTC'"
        [placeholder]="'Materia e tecnica (MTC)'">
      </app-input-vocabulary-autocomplete>
    </ng-container>
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      mat-icon-button
      type="button"
      (click)="removeMTCHandler(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    (click)="addMTCHandler()">
    {{ 'Aggiungi materia e tecnica' | translate }}
  </button>
</div>
